import React, { useState, useEffect, useRef } from 'react';

interface IDescription {
	media: any
	expanded: boolean
	toggleMediaDescription: () => void
}

const Description = ({ media, expanded, toggleMediaDescription }: IDescription) => {
	const [sizeCheck, updateSizeCheck] = useState<string>("unchecked")
	const descriptionRef = useRef<HTMLInputElement | null>(null)
	useEffect(() => {
		if (sizeCheck === "unchecked") {
			if (descriptionRef.current && descriptionRef.current.clientHeight <= 60) {
				updateSizeCheck("hidetoggle")
			}
			else {
				updateSizeCheck("checked")
			}
		}
	})

	if (media.description === undefined || media.description.length === 0) {
		return null;
	}

	if (sizeCheck === "hidetoggle" || sizeCheck === "unchecked") {
		return <div>
			<h2 className="text-black-secondary typography-body-2">Description</h2>
			<div className="mb-3 mb-lg-4">
				<div ref={descriptionRef} className={"collapse mb-3 unsw-collapse-peak show"} id="collapse-video-desc" dangerouslySetInnerHTML={{ __html:media.description }}></div>
			</div>
		</div>
	}

	return <div>
		<h2 className="text-black-secondary typography-body-2">Description</h2>
		<div className="mb-3 mb-lg-4">
			<div ref={descriptionRef} className={"collapse mb-3 unsw-collapse-peak"+(expanded ? " show" : "")} id="collapse-video-desc" dangerouslySetInnerHTML={{ __html:media.description }}></div>
			<button aria-controls="collapse-video-desc" aria-expanded={expanded} className="btn unsw-mw-0" type="button" onClick={toggleMediaDescription}>
				Show {expanded ? (<span>less</span>) : (<span>more</span>)}
			</button>
		</div>
	</div>
}

export default Description;